module.exports = __webpack_public_path__ + "img/wildaboutanimals.5bc7b860.png";